import { Action, initialState, State, TrackerState } from '../store/store';
import { Blocks } from 'factories/block';

export const setBlocks = (
  state: State = initialState,
  { data }: Action
): State => {
  const blocks = data as Blocks;
  const nextState = {
    ...state,
    blocks: { ...state.blocks },
    tracker: { ...state.tracker },
  };

  Object.keys(blocks).forEach(id => {
    const block = blocks[id];
    nextState.blocks[block.id] = block;
    nextState.tracker[block.id] = TrackerState.DIRTY;
  });

  return nextState;
};
